import { ChangeDetectorRef, Component, Input, NgZone, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiService } from "src/app/services";
import { PlanRegionWithApprovalStatus } from "../../../../generated-models/PlanRegionWithApprovalStatus";

@Component({
  standalone: false,
  templateUrl: "./plan-remove-modal.component.html",
  styleUrls: ["../../../../styles.scss", "../../plan.scss"],
})
export class PlanRemoveModalComponent implements OnInit {
  @Input() planRegions: PlanRegionWithApprovalStatus[]

  public aggregatedResult: string[] = [];
  public isCompleted = false;
  public confirmation = true;
  public inProgress = false;
  public message: string;
  public cancelButtonMsg = "No";
  public confirmInfo = "Please Confirm"

  constructor(
    public activeModal: NgbActiveModal,
    protected apiService: ApiService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit() { }

  submit() {
    this.confirmation = true;
    this.inProgress = true;
    this.confirmation = false;
    this.isCompleted = false;
    this.aggregatedResult = [];
    this.ngZone.run(() => {
      this.cdr.detectChanges();
    });

    this.planRegions.map((r) => {
      this.apiService.softDeletePlanRegion(r.ServiceTreeId, r.Region, r.Version, r.Blueprint).subscribe(
        () => {
          this.message = `Execution Plan (${r.ServiceTreeId}, ${r.Region}, ${r.Version}, ${r.Blueprint}) have been set to Removed status <b>successfully</b>.`;
          this.appendResult(this.message);
        },
        (err) => {
          this.message = `Execution Plan failed to set Removed status. <b>Error: ${err}</b>`;
          this.appendResult(this.message);
        },
      );
    });

    this.ngZone.run(() => {
      this.isCompleted = true;
      this.cancelButtonMsg = "Close";
      this.confirmInfo = "Set plans to removed status";
      this.cdr.detectChanges();
    });
  }

  private appendResult(message: string) {
    this.aggregatedResult.push(message);
    this.ngZone.run(() => {
      this.cdr.detectChanges();
    });
  }

  close() {
    this.activeModal.close(true);
  }
}
